import { Controller } from "@hotwired/stimulus"

// Fills the stars up to the one you picked, and SAVES IT IMMEDIATELY.
//
// The radios are real form fields, so a browser with no JavaScript still
// submits a rating along with "Add to my recipes" — the stars are the
// affordance rather than the mechanism, and that has not changed.
//
// WHAT CHANGED IS WHEN IT SAVES. The rating used to ride on the keep form
// alone, so rating a recipe and then hitting "Try again" threw it away —
// and a 1-star is the MORE informative rating, because it is the one
// somebody discards. Cody, 15 Sep: "can we have the rating saved without
// keeping?"
//
// Fire and forget: this is feedback, not a transaction. A failed save
// leaves the stars filled and the form field set, so keeping the recipe
// still carries the rating through the normal path.
export default class extends Controller {
  static targets = ["input", "star"]
  static values = { url: String }

  connect() {
    this.refresh()
  }

  refresh() {
    const chosen = this.inputTargets.find((input) => input.checked)
    const value = chosen ? Number(chosen.value) : 0

    this.starTargets.forEach((star) => {
      const filled = Number(star.dataset.value) <= value
      star.setAttribute("fill", filled ? "var(--color-ai)" : "none")
    })

    if (value > 0) this.save(value)
  }

  save(value) {
    if (!this.hasUrlValue || value === this.saved) return

    this.saved = value

    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token || "",
        "Accept": "application/json"
      },
      body: JSON.stringify({ rating: value })
    }).catch(() => {
      // Silent: the rating is still in the form field, so keeping the
      // recipe carries it through anyway.
      this.saved = null
    })
  }
}
